// extracted by mini-css-extract-plugin
export var buttonStylize = "stylize-module--button-stylize--R51EX";
export var heading = "stylize-module--heading--sjlTZ";
export var portrait = "stylize-module--portrait--OsBwd";
export var stylizeIntro = "stylize-module--stylize-intro--82ZKv";
export var subtitle = "stylize-module--subtitle--krSEC";